module.exports = {
  RESIZE_DEBOUNCE_DELAY: 100,
  AUTOCOMPLETE_DEBOUNCE_DELAY: 200,
  REQUEST_DEBOUNCE_DELAY: 30,
  TOOLTIP_HIDE_DELAY: 300,
};
